<template>
  <div>
    <el-row :gutter="10" style="margin: 10px 0">
      <el-col :xs="24" :lg="8" style="padding: 6px 0">
        <span style="margin-left: 20px"> 数据指标： </span>
        <el-select
          v-model="dataIndex"
          placeholder="请选择"
          @change="changeDataIndex"
          size="mini"
        >
          <el-option
            v-for="item in dataIndexOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="8" style="padding: 6px 0">
        <span style="margin-left: 20px"> 数据类型： </span>
        <el-select
          v-model="dataRange"
          @change="dataRangeChange"
          placeholder="请选择"
          size="mini"
          disabled
        >
          <el-option
            v-for="item in dataRangeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col
        :xs="24"
        :lg="8"
        style="padding: 6px 0"
        v-if="dataRange === 'quarter'"
      >
        <span>
          <quarterRange
            style="margin-left: 44px"
            :default-value="defaultQuarterValue"
            v-on:getQuarter="getQuarter"
          ></quarterRange>
        </span>
      </el-col>
      <el-col
        :xs="24"
        :lg="8"
        style="padding: 6px 0"
        v-if="dataRange === 'month'"
      >
        <span style="margin-left: 44px"> 时间： </span>
        <el-date-picker
          class="jiance_phone_date"
          :editable="false"
          :clearable="false"
          v-model="defaultMonthValue"
          type="monthrange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clear-icon
          value-format="yyyy-MM"
          size="mini"
          @change="changeMonth"
        >
        </el-date-picker>
      </el-col>
      <el-col
        :xs="24"
        :lg="8"
        style="padding: 6px 0"
        v-if="dataRange === 'halfyear'"
      >
        <span>
          <halfYear
            style="margin-left: 44px"
            :default-value="defaultQuarterValue"
            v-on:getQuarter="getHalfYear"
          ></halfYear>
        </span>
      </el-col>
      <el-col
        :xs="24"
        :lg="8"
        style="padding: 6px 0"
        v-if="dataRange === 'year'"
      >
        <span>
          <year-range
            style="margin-left: 44px"
            :start-time-def="startTimeDef"
            :end-time-def="endTimeDef"
            v-on:getYearRange="getYearRange"
          ></year-range>
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin: 10px 0">
      <el-col align="center" style="font-size: 16px">
        {{ parkName }}-{{
          dataIndexOptions.find((ele) => ele.value === dataIndex).label
        }}情况
      </el-col>
    </el-row>
    <el-row style="margin: 10px 0px">
      <el-col :span="24">
        <Area v-if="showArea" :area-data="areaData" />
      </el-col>
    </el-row>
    <el-link style="margin: 10px 15px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <el-row style="margin: 10px 0px">
      <el-col :span="24">
        <el-table
          v-loading="loading"
          size="mini"
          border
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
          :row-class-name="tableRowClassName"
          :data="tableData"
        >
          <el-table-column type="index" label="序号" width="50" fixed>
          </el-table-column>
          <el-table-column prop="dateRange" label="填报时间" fixed>
          </el-table-column>
          <el-table-column
            :label="
              dataIndexOptions.find((ele) => ele.value === dataIndex).label +
              '(' +
              unit +
              ')'
            "
          >
            <el-table-column
              prop="currentValue"
              sortable
              :formatter="handelFix2"
              label="本期止累计"
            >
            </el-table-column>
            <el-table-column
              prop="lastValue"
              sortable
              :formatter="handelFix2"
              label="上年同期"
            >
            </el-table-column>
            <el-table-column
              prop="prop"
              sortable
              :formatter="handelFix1"
              label="同比增长(%)"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Area from "@/components/Echarts/area.vue";
import quarterRange from "../../../components/dateUtils/quarterRange";
import YearRange from "../../../components/dateUtils/yearRange";
import halfYear from "@/components/dateUtils/halfYearRange.vue";
import { export2Excel } from "@/utils/utils";
export default {
  props: {
    nameDef: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    parkNameDef: {
      type: String,
      default: "",
    },
    regionCodeDef: {
      type: String,
      default: "",
    },
    dataIndexDef: {
      type: String,
      default: "",
    },
    dataRangeDef: {
      type: String,
      default: "",
    },
    timesDef: {
      type: String,
      default: "",
    },
    unitDef: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      value1: "",
      showArea: false,
      loading: false,
      areaName: "",
      exportLabel: "<<点击此处可导出报表",
      startTime: "",
      startTimeDef: "",
      endTime: "",
      QuarterValue: [],
      currQuarter: "",
      name: this.nameDef,
      unit: this.unitDef,
      parkName: this.parkNameDef,
      endTimeDef: "",
      srcDataList: "",
      dialogTableVisible: false,
      queryData: {
        name: this.name,
        parkName: this.parkName,
      },
      dataIndexOptions: [
        {
          value: "工业总产值",
          label: "工业总产值",
          unit: "亿元",
        },
        {
          value: "营业收入",
          label: "营业收入",
          unit: "亿元",
        },
        {
          value: "增加值",
          label: "增加值",
          unit: "亿元",
        },
        {
          value: "实缴税金",
          label: "实缴税金",
          unit: "亿元",
        },
        {
          value: "基础设施建设本年投资额",
          label: "基础设施建设本年投资额",
          unit: "亿元",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "halfyear",
          label: "半年度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataIndex: this.dataIndexDef, //数据指标
      dataRange: this.dataRangeDef, //数据类型
      times: this.timesDef, //时间
      defaultQuarterValue: [], //时间
      defaultMonthValue: "", //时间
      tableData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: this.unit,
      },
    };
  },
  components: {
    YearRange,
    Area,
    quarterRange,
    halfYear,
  },
  watch: {
    dataRange: function (value, oldValue) {
      if (value === "quarter") {
        this.times = this.defaultQuarterValue;
        this.startTime =
          this.defaultQuarterValue[0].split("-")[0] +
          "-0" +
          parseInt(this.defaultQuarterValue[0].split("-")[1]);
        this.endTime =
          this.defaultQuarterValue[1].slice(0, 4) +
          "-0" +
          parseInt(this.defaultQuarterValue[1].slice(5, 6));
        if (this.currQuarter == 1) {
          this.endTime = this.defaultQuarterValue[1].slice(0, 4) + "-03";
        } else if (this.currQuarter == 2) {
          this.endTime = this.defaultQuarterValue[1].slice(0, 4) + "-06";
        } else if (this.currQuarter == 3) {
          this.endTime = this.defaultQuarterValue[1].slice(0, 4) + "-09";
        } else if (this.currQuarter == 4) {
          this.endTime = this.defaultQuarterValue[1].slice(0, 4) + "-12";
        }
      } else if (value === "month") {
        this.times = this.defaultMonthValue;
        this.startTime = this.defaultMonthValue[0];
        this.endTime = this.defaultMonthValue[1];
      } else {
        this.startTimeDef = new Date().getFullYear() - 4 + "";
        this.endTimeDef = new Date().getFullYear() + "";
        this.startTime = new Date().getFullYear() - 4 + "-01";
        this.endTime = new Date().getFullYear() + "-12";
      }
      this.initData();
    },
  },
  methods: {
    changeMonth() {
      console.log("defaultMonthValue", this.defaultMonthValue);
      this.startTime = this.defaultMonthValue[0];
      this.endTime = this.defaultMonthValue[1];
      this.initData();
    },
    getHalfYear(value) {
      if (value[0].slice(5, 6) == 1) {
        this.startTime = value[0].slice(0, 4) + "-01";
      } else {
        this.startTime = value[0].slice(0, 4) + "-07";
      }
      if (value[1].slice(5, 6) == 1) {
        this.endTime = value[1].slice(0, 4) + "-01";
      } else {
        this.endTime = value[1].slice(0, 4) + "-07";
      }
      this.initData();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    handelFix1(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else if (value === "halfyear") {
        this.dataTpye = "currHalfYear";
      } else {
        this.dataTpye = "all";
      }
    },
    initData() {
      this.loading = true;
      this.queryData.startTime = this.startTime;
      this.queryData.endTime = this.endTime;
      this.queryData.name = this.name;
      this.queryData.parkName = this.parkName;
      console.log(this.queryData, this.queryData);
      this.$axios
        .get(
          `/business/upgrade/park/selectOneParkMsg?type=${this.queryData.name}&startDate=${this.queryData.startTime}&endDate=${this.queryData.endTime}&parkName=${this.queryData.parkName}`
        )
        .then((res) => {
          console.log(res.data.data);
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            pre: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            unit: this.unit,
          };
          this.showArea = false;
          this.loading = false;
          this.srcDataList = res.data.data;
          this.getShowData();
        });
    },
    getQuarter(value) {
      this.QuarterValue = value;
      const startArr = ["-01", "-04", "-07", "-10"];
      const endArr = ["-03", "-06", "-09", "-12"];
      this.startTime =
        value[0].slice(0, 4) + startArr[parseInt(value[0].slice(5, 6)) - 1];
      this.endTime =
        value[1].slice(0, 4) + endArr[parseInt(value[1].slice(5, 6)) - 1];
      this.initData();
    },
    getYearRange(value) {
      this.startTime = value[0] + "-01";
      this.endTime = value[1] + "-04";
      this.initData();
    },
    getShowData() {
      if (this.dataRange === "quarter") {
        this.getShowQuarterData();
      } else if (this.dataRange === "year") {
        this.getShowYearData();
      } else if (this.dataRange === "halfyear") {
        this.getShowHalfYearData();
      } else if (this.dataRange === "month") {
        this.getShowMonthData();
      }
    },
    getShowMonthData() {
      const self = this;
      const resultData = {};

      let resultList = [];
      // 计算累计数据

      this.tableData = [];
      resultList = this.srcDataList;
      console.log("resultList", resultList);
      // 展示数据过滤
      resultList.forEach((item) => {
        if (item.prop == null) {
          item.prop = 0;
        }
        this.areaData.xAxis.push(item.dateRange);
        this.areaData.curr.name = "本期止累计";
        this.areaData.pre.name = "上年同期";
        this.areaData.profit.name = "同比增速";
        this.areaData.curr.data.push(item.currentValue);
        this.areaData.pre.data.push(item.lastValue);
        this.areaData.profit.data.push(item.prop == null ? 0 : item.prop);
        this.tableData.push(item);
      });

      console.log("this.tableData", this.tableData);
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getShowHalfYearData() {
      const self = this;
      const resultData = {};

      let resultList = [];
      // 计算累计数据

      this.tableData = [];
      resultList = this.srcDataList;
      console.log("resultList", resultList);
      // 展示数据过滤
      resultList.forEach((item) => {
        if (item.prop == null) {
          item.prop = 0;
        }
        this.areaData.xAxis.push(item.dateRange);
        this.areaData.curr.name = "本期止累计";
        this.areaData.pre.name = "上年同期";
        this.areaData.profit.name = "同比增速";
        this.areaData.curr.data.push(item.currentValue);
        this.areaData.pre.data.push(item.lastValue);
        this.areaData.profit.data.push(item.prop == null ? "0" : item.prop);
        this.tableData.push(item);
      });
      console.log("this.tableData", this.tableData);
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getShowQuarterData() {
      const self = this;
      const resultData = {};

      let resultList = [];
      // 计算累计数据

      this.tableData = [];
      // 展示数据过滤
      resultList = this.srcDataList;
      resultList.forEach((item) => {
        if (item.prop == null) {
          item.prop = 0;
        }
        this.areaData.xAxis.push(item.dateRange);
        this.areaData.curr.name = "本期止累计";
        this.areaData.pre.name = "上年同期";
        this.areaData.profit.name = "同比增速";
        this.areaData.curr.data.push(item.currentValue);
        this.areaData.pre.data.push(item.lastValue);
        this.areaData.profit.data.push(item.prop == null ? "0" : item.prop);
        this.tableData.push(item);
      });
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getShowYearData() {
      const self = this;
      const resultData = {};
      this.srcDataList.forEach((item) => {
        if (resultData.hasOwnProperty(item.year_query)) {
          resultData[item.year_query].push(item);
        } else {
          resultData[item.year_query] = [];
          resultData[item.year_query].push(item);
        }
      });
      let resultList = [];
      // 计算累计数据

      this.tableData = [];
      // 展示数据过滤
      resultList = this.srcDataList;
      resultList.forEach((item) => {
        if (item.prop == null) {
          item.prop = 0;
        }
        this.areaData.xAxis.push(item.dateRange);
        this.areaData.curr.name = "本期止累计";
        this.areaData.pre.name = "上年同期";
        this.areaData.profit.name = "同比增速";
        this.areaData.curr.data.push(item.currentValue);
        this.areaData.pre.data.push(item.lastValue);
        this.areaData.profit.data.push(item.prop == null ? "0" : item.prop);
        this.tableData.push(item);
      });
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    changeDataIndex(value) {
      this.$emit("changeDataIndex", value);
      this.name = value;
      this.unit = this.dataIndexOptions.find((ele) => ele.value === value).unit;
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      let year = this.timesDef.slice(0, 4);
      this.defaultMonthValue = [year + "-01", this.timesDef || year + "-04"];
      //下面是几个if
      if (this.timesDef) {
        const selectMonth = parseInt(this.timesDef.split("-").pop());
        if (selectMonth >= 1 && selectMonth <= 3) {
          this.currQuarter = 1;
          return [year + "-" + "01", year + "-1"];
        } else if (selectMonth >= 4 && selectMonth <= 6) {
          this.currQuarter = 2;
          return [year + "-" + "1", year + "-2"];
        } else if (selectMonth >= 7 && selectMonth <= 9) {
          this.currQuarter = 3;
          return [year + "-" + "1", year + "-3"];
        } else if (selectMonth >= 10 && selectMonth <= 12) {
          this.currQuarter = 4;
          return [year + "-" + "1", year + "-4"];
        }
        //下面是几个if
        return [year + "-" + "1", year + "-" + selectMonth];
      } else {
        return [year + "-" + "1", year + "-" + "4"];
      }
    },
    yearChange(value) {
      this.times = value + "-04";
      this.initData();
    },
    monthChange(value) {
      this.startTime = value[0].slice(0, 4) + "-01";
      this.endTime = value[1].slice(0, 4) + "-12";
      this.initData();
    },
    exportData() {
      let column = [
        {
          title: "填报时间",
          key: "dateRange",
          rowspan: 2,
        },
        {
          title:
            this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
              .label +
            "(" +
            this.unit +
            ")",
          data: [
            {
              title: "本期止累计",
              toFixed: 2,
              key: "currentValue",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "lastValue",
            },
            {
              title: "同比增长(%)",
              toFixed: 1,
              key: "prop",
            },
          ],
          colspan: 3,
        },
      ];
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr =
          this.startTime.slice(0, 4) + "年到" + this.endTime.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        timeStr =
          this.QuarterValue[0].split("-")[0] +
          "年第" +
          parseInt(this.QuarterValue[0].split("-")[1]) +
          "季度到" +
          this.QuarterValue[1].split("-")[0] +
          "年第" +
          parseInt(this.QuarterValue[1].split("-")[1]) +
          "季度";
      } else if (this.dataRange === "halfyear") {
        timeStr = this.startTime + "年" + "到" + this.endTime;
      } else {
        timeStr =
          this.times[0].slice(0, 4) +
          "年" +
          this.times[0].slice(5, 7) +
          "月到" +
          this.times[1].slice(0, 4) +
          "年" +
          this.times[1].slice(5, 7) +
          "月";
      }
      export2Excel(column, this.tableData, this.title);
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.QuarterValue = this.defaultQuarterValue;
    this.times = this.defaultMonthValue;
    if (this.dataRangeDef === "year") {
      // 季度数据，默认取近五年的数据
      let year = this.timesDef.slice(0, 4);
      this.endTimeDef = year + "";
      year = parseInt(year) - 4;
      this.startTimeDef = year + "";
      this.startTime = year + "-01";
      this.endTime = this.timesDef;
    } else if (this.dataRangeDef === "quarter") {
      // 季度数据，默认取当年全年的数据
      this.startTime = this.timesDef.slice(0, 4) + "-01";
      this.endTime = this.timesDef;
    } else if (this.dataRangeDef === "month") {
      // 季度数据，默认取当年全年的数据
      this.startTime = this.timesDef.slice(0, 4) + "-01";
      this.endTime = this.timesDef;
    } else if (this.dataRangeDef === "halfyear") {
      this.startTime = this.timesDef.slice(0, 4) + "-01";
      this.endTime = this.timesDef;
    }
    this.initData();
  },
};
</script>